'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScrollbarWidth = exports.isPropertySupported = exports.isEqual = undefined;

var _lodash = require('lodash.isequal');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isPropertySupported(name, value) {
  var propName = name;

  var element = document.createElement('p');
  document.body.insertBefore(element, null);

  element.style[propName] = value;

  var propValue = window.getComputedStyle(element, null).getPropertyValue(propName);

  document.body.removeChild(element);

  return propValue === value;
}

function getScrollbarWidth() {
  var outerDiv = document.createElement('div');
  var innerDiv = document.createElement('div');

  outerDiv.style.overflow = 'scroll';

  document.body.insertBefore(outerDiv, null);
  outerDiv.insertBefore(innerDiv, null);

  var scrollbarWidth = outerDiv.offsetWidth - innerDiv.offsetWidth;

  document.body.removeChild(outerDiv);

  return scrollbarWidth;
}

exports.isEqual = _lodash2.default;
exports.isPropertySupported = isPropertySupported;
exports.getScrollbarWidth = getScrollbarWidth;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInV0aWxzLmVzNiJdLCJuYW1lcyI6WyJpc1Byb3BlcnR5U3VwcG9ydGVkIiwibmFtZSIsInZhbHVlIiwicHJvcE5hbWUiLCJlbGVtZW50IiwiZG9jdW1lbnQiLCJjcmVhdGVFbGVtZW50IiwiYm9keSIsImluc2VydEJlZm9yZSIsInN0eWxlIiwicHJvcFZhbHVlIiwid2luZG93IiwiZ2V0Q29tcHV0ZWRTdHlsZSIsImdldFByb3BlcnR5VmFsdWUiLCJyZW1vdmVDaGlsZCIsImdldFNjcm9sbGJhcldpZHRoIiwib3V0ZXJEaXYiLCJpbm5lckRpdiIsIm92ZXJmbG93Iiwic2Nyb2xsYmFyV2lkdGgiLCJvZmZzZXRXaWR0aCIsImlzRXF1YWwiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7Ozs7O0FBRUEsU0FBU0EsbUJBQVQsQ0FBNkJDLElBQTdCLEVBQW1DQyxLQUFuQyxFQUEwQztBQUN4QyxNQUFNQyxXQUFXRixJQUFqQjs7QUFFQSxNQUFNRyxVQUFVQyxTQUFTQyxhQUFULENBQXVCLEdBQXZCLENBQWhCO0FBQ0FELFdBQVNFLElBQVQsQ0FBY0MsWUFBZCxDQUEyQkosT0FBM0IsRUFBb0MsSUFBcEM7O0FBRUFBLFVBQVFLLEtBQVIsQ0FBY04sUUFBZCxJQUEwQkQsS0FBMUI7O0FBRUEsTUFBTVEsWUFBWUMsT0FDZkMsZ0JBRGUsQ0FDRVIsT0FERixFQUNXLElBRFgsRUFFZlMsZ0JBRmUsQ0FFRVYsUUFGRixDQUFsQjs7QUFJQUUsV0FBU0UsSUFBVCxDQUFjTyxXQUFkLENBQTBCVixPQUExQjs7QUFFQSxTQUFPTSxjQUFjUixLQUFyQjtBQUNEOztBQUVELFNBQVNhLGlCQUFULEdBQTZCO0FBQzNCLE1BQU1DLFdBQVdYLFNBQVNDLGFBQVQsQ0FBdUIsS0FBdkIsQ0FBakI7QUFDQSxNQUFNVyxXQUFXWixTQUFTQyxhQUFULENBQXVCLEtBQXZCLENBQWpCOztBQUVBVSxXQUFTUCxLQUFULENBQWVTLFFBQWYsR0FBMEIsUUFBMUI7O0FBRUFiLFdBQVNFLElBQVQsQ0FBY0MsWUFBZCxDQUEyQlEsUUFBM0IsRUFBcUMsSUFBckM7QUFDQUEsV0FBU1IsWUFBVCxDQUFzQlMsUUFBdEIsRUFBZ0MsSUFBaEM7O0FBRUEsTUFBTUUsaUJBQWlCSCxTQUFTSSxXQUFULEdBQXVCSCxTQUFTRyxXQUF2RDs7QUFFQWYsV0FBU0UsSUFBVCxDQUFjTyxXQUFkLENBQTBCRSxRQUExQjs7QUFFQSxTQUFPRyxjQUFQO0FBQ0Q7O1FBR0NFLE87UUFDQXJCLG1CLEdBQUFBLG1CO1FBQ0FlLGlCLEdBQUFBLGlCIiwiZmlsZSI6InV0aWxzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IGlzRXF1YWwgZnJvbSAnbG9kYXNoLmlzZXF1YWwnO1xuXG5mdW5jdGlvbiBpc1Byb3BlcnR5U3VwcG9ydGVkKG5hbWUsIHZhbHVlKSB7XG4gIGNvbnN0IHByb3BOYW1lID0gbmFtZTtcblxuICBjb25zdCBlbGVtZW50ID0gZG9jdW1lbnQuY3JlYXRlRWxlbWVudCgncCcpO1xuICBkb2N1bWVudC5ib2R5Lmluc2VydEJlZm9yZShlbGVtZW50LCBudWxsKTtcblxuICBlbGVtZW50LnN0eWxlW3Byb3BOYW1lXSA9IHZhbHVlO1xuXG4gIGNvbnN0IHByb3BWYWx1ZSA9IHdpbmRvd1xuICAgIC5nZXRDb21wdXRlZFN0eWxlKGVsZW1lbnQsIG51bGwpXG4gICAgLmdldFByb3BlcnR5VmFsdWUocHJvcE5hbWUpO1xuXG4gIGRvY3VtZW50LmJvZHkucmVtb3ZlQ2hpbGQoZWxlbWVudCk7XG5cbiAgcmV0dXJuIHByb3BWYWx1ZSA9PT0gdmFsdWU7XG59XG5cbmZ1bmN0aW9uIGdldFNjcm9sbGJhcldpZHRoKCkge1xuICBjb25zdCBvdXRlckRpdiA9IGRvY3VtZW50LmNyZWF0ZUVsZW1lbnQoJ2RpdicpO1xuICBjb25zdCBpbm5lckRpdiA9IGRvY3VtZW50LmNyZWF0ZUVsZW1lbnQoJ2RpdicpO1xuXG4gIG91dGVyRGl2LnN0eWxlLm92ZXJmbG93ID0gJ3Njcm9sbCc7XG5cbiAgZG9jdW1lbnQuYm9keS5pbnNlcnRCZWZvcmUob3V0ZXJEaXYsIG51bGwpO1xuICBvdXRlckRpdi5pbnNlcnRCZWZvcmUoaW5uZXJEaXYsIG51bGwpO1xuXG4gIGNvbnN0IHNjcm9sbGJhcldpZHRoID0gb3V0ZXJEaXYub2Zmc2V0V2lkdGggLSBpbm5lckRpdi5vZmZzZXRXaWR0aDtcblxuICBkb2N1bWVudC5ib2R5LnJlbW92ZUNoaWxkKG91dGVyRGl2KTtcblxuICByZXR1cm4gc2Nyb2xsYmFyV2lkdGg7XG59XG5cbmV4cG9ydCB7XG4gIGlzRXF1YWwsXG4gIGlzUHJvcGVydHlTdXBwb3J0ZWQsXG4gIGdldFNjcm9sbGJhcldpZHRoLFxuXG59O1xuIl19


//////////////////
// WEBPACK FOOTER
// ./~/animakit-core/lib/utils.js
// module id = 683
// module chunks = 0